import {stepsUuidMapGenerator} from '@/utils/stepsUuidMapGenerator';

export const STEPS = {
  NAME_AND_BIRTHDATE: 'name-and-birthdate',
  CREATOR_SEGMENT: 'creator-segment',
  LOCATION: 'location',
  GENDER: 'gender',
  SPECIALTIES: 'specialties',
  CAPABILITIES: 'capabilities',
  SYNC_PLATFORMS: 'sync-platforms',
  COLLABORATION_RATE: 'collaboration-rate',
  PORTFOLIO: 'portfolio',
  BIO: 'bio',
  COMPLETION: 'completion',
  INSTAGRAM_INSTRUCTIONS: 'instagram-instructions',
  REONBOARDING: 'reonboarding',
} as const;

export type Step = (typeof STEPS)[keyof typeof STEPS];

export const ONBOARDING_STEPS_UUID_MAP = stepsUuidMapGenerator<Step>(STEPS);

export const DEFAULT_STEP_ORDER: Step[] = [
  STEPS.NAME_AND_BIRTHDATE,
  STEPS.CREATOR_SEGMENT,
  STEPS.LOCATION,
  STEPS.GENDER,
  STEPS.SPECIALTIES,
  STEPS.CAPABILITIES,
  STEPS.SYNC_PLATFORMS,
  STEPS.COLLABORATION_RATE,
  STEPS.PORTFOLIO,
  STEPS.BIO,
  STEPS.COMPLETION,
];
